export default function Attribution() {
  return (
    <div class="attribution">
      Challenge by &nbsp;
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">
        Frontend Mentor
      </a>
      . Coded by{" "}
      <a href="https://aashar-mehmood.github.io/AasharMehmood/">
        Aashar Mehmood
      </a>
    </div>
  );
}
